import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { gridIcon } from '@g99-product-web-ui/shared-util-lib';

import { ISharedTab } from '../../interfaces/shared-tab.interfaces';

@Component({
  selector: 'lib-shared-tab',
  templateUrl: './shared-tab.component.html',
  styleUrls: ['./shared-tab.component.scss'],
  standalone: false,
})
export class SharedTabComponent implements OnInit {
  @Input() public tabs: ISharedTab[] = [];
  @Input() public activeTab = ''; // input from parent
  @Input() public routingMode: 'none' | 'queryParams' | 'routing' = 'none'; // Routing mode
  @Input() public basePath = '';
  @Input() public showTitleOnMobile = true;
  @Input() public showAsTabOnMobile = false;
  @Input() public equalWidthTabs = false;
  @Input() public queryParamsKey = 'tab'; // Key for query params or routing
  @Input() public showGridOnLeft = false;
  @Output() public tabClick = new EventEmitter<string>(); // emit event
  protected gridIcon = gridIcon;

  protected isSidebarVisible = false;
  constructor(
    private readonly _router: Router,
    private readonly _route: ActivatedRoute
  ) {}

  // Close sidebar when clicking outside
  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const gridIconClicked = target.closest('.grid-icon');
    const sidebarClicked = target.closest('.menu-container');

    // If click is not on grid icon and not on sidebar, close sidebar
    if (!gridIconClicked && !sidebarClicked && this.isSidebarVisible) {
      this.isSidebarVisible = false;
    }
  }

  ngOnInit() {
    const activeRoute = this._router.url;

    if (this.routingMode === 'queryParams') {
      // Use query parameters
      this._route.queryParams.subscribe((params) => {
        const activeTabParam = params[this.queryParamsKey];
        this.activeTab = activeTabParam || this.activeTab || this.tabs[0].route;
      });
    } else if (this.routingMode === 'routing') {
      // Use path parameters
      const currentRoute = this._router.url;
      const lastPath = currentRoute.split('/');
      const activeTab = this.tabs.find(
        (tab) => tab.route === lastPath[lastPath.length - 1]
      );

      if (activeTab) {
        this.activeTab = activeTab.route;
      }
    } else {
      // Default to the first tab if no routing mode is used
      this.activeTab = this.activeTab || this.tabs[0]?.label || '';
    }

    this.basePath = activeRoute.split('/')[1];
  }

  protected onTabClick(route: string, label: string) {
    this.isSidebarVisible = false;
    if (this.activeTab === route) {
      return;
    }
    this.activeTab = label;

    if (this.routingMode === 'routing') {
      // Navigate using path parameters
      this.tabClick.emit(route); // Emit tab click event to the parent
      this._router.navigate([route], { relativeTo: this._route });
    } else if (this.routingMode === 'queryParams') {
      // Navigate using query parameters
      this.tabClick.emit(route); // Emit tab click event to the parent
      this._router.navigate([], {
        queryParams: { [this.queryParamsKey]: route },
        queryParamsHandling: 'merge',
      });
    } else {
      // No navigation if routingMode is 'none'
      this.tabClick.emit(label); // Emit tab click event to the parent
      this.activeTab = label;
    }
  }

  protected toggleSidebar(): void {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  protected isActive(label: string): boolean {
    return label === this.activeTab;
  }
}
